import { SHIFTS } from "@/constants/shifts";
import { formatQuantity } from "./formatQuantity";

/**
 * Redovi "namirnica / jelo po smenama" za telefon (Namirnice, Jela): abecedno, sa ukupnom količinom i količinom
 * po smeni (samo smene u kojima postoji). Zahteva nasleđen stari tab sa `shiftItems` (stavke sa `menu`,
 * `shift_one`…`shift_four` i `total`), `filters` i `customSearch`.
 */
export default {
  computed: {
    locale() {
      const config = this.getCurrentLanguageConfig();
      return config.script === "latin" && config.locale === "sr-RS" ? "sr-Latn-RS" : config.locale;
    },
    shiftRows() {
      const search = this.filters.search;
      const found = search ? this.customSearch(this.shiftItems, [{ value: "menu" }], search) : this.shiftItems;
      return [...found]
        .sort((a, b) => a.menu.localeCompare(b.menu))
        .map((item, index) => ({
          key: `${item.menu}-${index}`,
          name: item.menu,
          total: formatQuantity(item.total, this.locale),
          shifts: SHIFTS.map((shift) => ({ id: shift.id, quantity: item[shift.key] || 0 }))
            .filter((shift) => shift.quantity > 0)
            .map((shift) => ({ ...shift, quantity: formatQuantity(shift.quantity, this.locale) })),
        }));
    },
  },
};
